function spriteValidator(value, field, obj) {
  console.log('sprite validtor', value, field, obj);
  return [];
  if (value === 'placeholder.png') {
    return ['Choose an image.'];
  } else {
    return []
  }
}
import FloatieFeature from './features/floatie.json';
import DragLeftRightFeature from './features/drag.json'
import DragTopDownFeature from './features/dragvert.json'
import {sortBy, flatten, uniqBy, uniq, includes, range, compact, groupBy, toPairs, isFunction, isString} from 'lodash';

const SUPERUSER_LEVEL = 3;
const ADVANCED_LEVEL = 2;
const NOOB_LEVEL = 1;

function createNoLinkGrouping() {
  return [];
}
function createSequenceLinkGrouping({name}) {
  if (name === 'change') {
    return {
      title: "When Step Changes",
      description: "Do something whenever the step changes.",
      name: "change"
    }
  }
  const title = "Step: " + name;
  const number = (name == '1' ? '1st ' : (name == '2' ? '2nd' : (name == '3' ? '3rd' : (name + 'th'))));
  const description = "Do something when is activated for the " + number + " time."
  return {
    title,
    description,
    name
  }
}
function createRestrictPositionGrouping({name}) {
    //slots: ['any', 'left', 'right', 'top', 'bottom'],
  const mappings = {
    any:{
      title:'Touches Any Boundary',
      description:'Do something when the toy touches any of the 4 boundaries.'
    },
    left:{
      title:'Touches Left Boundary',
      description:'Do something when the toy touches the left-side boundary.'
    },
    right:{
      title:'Touches Right Boundary',
      description:'Do something when the toy touches the right-side boundary.'
    },
    top:{
      title:'Touches Top Boundary',
      description:'Do something when the toy touches the top boundary.'
    },
    bottom:{
      title:'Touches Bottom Boundary',
      description:'Do something when the toy touches the bottom boundary.'
    }
  }
  return {...mappings[name], name}
}

function createTweenLinkGrouping({name}) {
  const verb = {
    'finish':'Finished',
    'start':'Started'
  }
  const title = 'When Animation ' + verb[name];
  return {
    title,
    description:"Do something as soon as the animation has " + verb[name].toLowerCase() + ".",
    name
  }
}
function createTapControllerLinkGrouping({name}) {
  const adjverb = {
    finish: 'finished',
    start: 'begins',
    busy: 'is pressing'
  }
  const title = 'When The User  ' + adjverb[name];
  const description = "Do something when the user tap " + adjverb[name];
  return {
    title,
    description,
    name
  }
}

function createSwipeControllerLinkGrouping({name}) {
  const title = 'When User Swipes in ' + name + ' direction';
  const description = "Do something when the user swipes in the " + name + " direction.";
  return {
    title,
    description,
    name
  }
}

function createBySlotNameLinkGrouping(item){
  const slots = {
    start: {
      title: `When the ${item} starts`,
    },
    finish: {
      title: `When the ${item} finishes`
    },
    change: {
      title:  `When the ${item} changes`
    },
    link: {
      title: `When the ${item} Is Created`,
      description: `Do something as soon as the ${item} has been added to the scene.`
    }
  }

  return ({name}) => {
    let comp = slots[name];
    if(comp)
    {
      return {
        title: comp.title,
        name,
        description: comp.description ? comp.description: comp.title
      }
    }else
    {
      //TODO report back as a bug
      return {
        title: name,
        name,
        description: `Seems we forgot to do something here, please report it to us`
      }
    }

  }

}

function createKeyControllerLinkGrouping({name}) {
  const title = 'When User Presses ' + name
  return {
    title,
    name
  }
}
function createCollisionWithLinkGrouping({name}) {
  const returns = {
    begin:{
      title:'When Collision Begins',
      description:"Do something when the collision begins"
    },
    end:{
      title:'When Collision Ends',
      description:"Do something when the collision end"
    },
    busy:{
      title:'When Collision Is Busy',
      description:"Do something when the collision is busy"
    },
    beginOther:{
      title:'When Collision Begins (Other)',
      description:"Do something on the other toy, when the collision begins"
    },
    endOther:{
      title:'When Collision Ends (Other)',
      description:"Do something on the other toy, when the collision ends"
    },
    busyOther:{
      title:'When Collision Is Busy (Other)',
      description:"Do something on the other toy, when the collision is busy"
    }
  }
  return {name,...returns[name]};
}

function createDefaultLinkGrouping(
    title = 'Create Immediately',
    description = "When Condition Is Met") {
  return ({name}) => {
      if (name === 'link' || name === 'create') {
        return {
          title,
          name,
          description
        }
      }else{
        console.log(`BROKEN LinkGroup ${name} == ${title} == ${description}`);
      }
      return {
        title:"Dunno Know " + name,
        name,
        description
      }
  }
}


const categories = {
  'behaviour': {
    name:'Behaviour',
    key:'behaviour',
    color:'#007A83',
  },
  'scene': {
    name:'Scene',
    key:'scene',
    color:'#cecece',
  },
  'input': {
    name:'Input',
    key:'input',
    color:'#9E0095'
  },
  'animations': {
    name:'Animations',
    key:'animations',
    color:'#009124'
  },
  'scripting': {
    name:'Scripting',
    key:'scripting',
    color:'#FF4958'
  },
  'change': {
    name:'Change',
    key:'change',
    color:'#aEaEaE'
  },
  'create': {
    name:'Create',
    key:'create',
    color:'#904713'
  },
  'physics': {
    name:'Physics',
    key:'physics',
    color:'#001089'
  },
  'misc': {
    name:'Other',
    key:'misc',
    color:'#FEFFFD',
  },
  'toys': {
    name:'Library',
    key:'toys',
    color:'#904713'
  },
  'features': {
    name:'Features',
    key:'features',
    color:'#904713'
  },

}
const typeList = sortBy([
  {
    type: 'none',
    text: 'None',
    hidden: true,
    description: [].join("\n"),
    slots: ['link']
  },

  {
    type: 'slot',
    text: 'Slot',
    category: categories.misc,
    level: SUPERUSER_LEVEL,
    description: [
      'Slot For us in custom behaviours. Allows you to customize events based on happenings inside the behaviour'
    ].join("\n"),
    //slots:['link']
    slots: (gamedata, c) => {
      return [
        c.name
      ]
    },
    iconName: 'ToyBrickMarker'
  },

  {
    type: 'tween',
    text: 'Animate',
    level: NOOB_LEVEL,
    category: categories.animations,
    description: [
      "Animate the appearance of a toy over a time period."
    ].join("\n"),
    slots: [{
      name:'finish',
      description:'When Tween Finishes'
    },
    {
      name:'start',
      description:'When Tween Starts'
    }],
    createNew: () => {
      return {
        quickAnimate:true,
        quicktweens: [],
        type: 'tween',
        time: 0.5,

        startDelay: 0,
        loopDelay: 0,
        flipDelay: 0,
        loop: false,
        flip: false,
        v2: true, // this means angles are in degrees

        reset: true,

        tweens: [
          {
            group: "Zoom",
            name: 'Zoom In',
            property: 'scalebothglobal',
            from: 0,
            to: 1,
            tween: 'easeOutQuad'
          },
        ]
      }
    },
    dataSchema:{
      groups:[
        {
          label:'Timing',
          fields:[
            {
              type: "numberOrVariable",
              inputType: "number",
              label: "Duration (s)",
              model: "time",
            },
            {
              type: "numberOrVariable",
              inputType: "number",
              label: "Start Delay (s)",
              model: "startDelay",
            },
            {
              type: "toggleSwitch",
              label: "Loop Tween",
              model: "loop",
              default:false
            },
            {
              type: "numberOrVariable",
              label: "Loop Delay",
              model: "loopDelay",
            },
            {
              type: "toggleSwitch",
              label: "Flip Tween",
              model: "flip",
              default:false
            },
            {
              type: "numberOrVariable",
              label: "Flip Delay",
              model: "flipDelay",
            },
            {
              type: "toggleSwitch",
              label: "Reset on Remove",
              model: "reset",
            },
          ]
        },
        {
          label:'Tweens',
          fields:[{
            type:"array",
            label:"Tweens",
            model:"tweens",
            showRemoveButton: true,
            items: {
              type: 'object',
              default: {},
              schema: {
                fields:[
            {
              type:"select",
              label:"Property",
              model:"property",
              values:[
                {name:'X',id:'x'},
                {name:'Y',id:'y'},
                // {name:'dX',id:'dx'},
                // {name:'dY',id:'dy'},
                {name:'Scale Local X',id:'scalex'},
                {name:'Scale Local Y',id:'scaley'},
                {name:'Scale Both Local',id:'scaleboth'},
                {name:'Scale Both Global',id:'scalebothglobal'},
                {name:'Scale Both Local Absolute',id:'scalebothabs'},
                {name:'Scale X Local Absolute',id:'scalexabs'},
                {name:'Scale Y Local Absolute',id:'scaleyabs'},
                {name:'Scale Both Global Absolute',id:'scalebothglobalabs'},
                {name:'Scale X Global Absolute',id:'scalexglobalabs'},
                {name:'Scale Y Global Absolute',id:'scaleyglobalabs'},
                {name:'Scale Global X',id:'scaleglobalx'},
                {name:'Scale Global Y',id:'scaleglobaly'},
                {name:'Rotation',id:'rotation'},
                // {name:'Circle Start Angle',id:'circleStartAngle'},
                // {name:'Circle End Angle',id:'circleEndAngle'},
                {name:'Alpha',id:'alpha'},
                {name:'Z Index',id:'zindex'},
                // {name:'Text',id:'text'},
              ]

            },
            {
              type: "numberOrVariable",
              inputType: "number",
              label: "Start Value",
              model: "from",
            },
            {
              type: "numberOrVariable",
              inputType: "number",
              label: "End Value",
              model: "to",
            },
            {
              type: "tween-select",
              label: "Tween",
              model: "tween",
            }
                ]
              }
            }

          }]
        }
      ],

    },
    quicktweenSchema: {
        fields:[
          {
            type: "numberOrVariable",
            inputType: "number",
            label: "Duration (s)",
            model: "time",
          },
          {
            type: "numberOrVariable",
            inputType: "number",
            label: "Start Delay (s)",
            model: "startDelay",
          },
          {
            type: "toggleSwitch",
            label: "Loop Tween",
            model: "loop",
            default:false
          },
          {
            type: "numberOrVariable",
            label: "Loop Delay",
            model: "loopDelay",
          },
          {
            type: "toggleSwitch",
            label: "Flip Tween",
            model: "flip",
            default:false
          },
          {
            type: "numberOrVariable",
            label: "Flip Delay",
            model: "flipDelay",
          },
          {
            type: "toggleSwitch",
            label: "Reset on Remove",
            model: "reset",
          },
        ]
    },
    quickSchema:{
      fields:[
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "Duration (s)",
          model: "time",
        },
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "Start Delay (s)",
          model: "startDelay",
        },
      ]

    },
    condensedSchema: {
      groups:[
        /*
        {
          tag:'div',
          styleClasses: "w-full flex-none",
          fields: [
            {
              type: "label",
              inputType: "number",
              label: "Duration (s)",
              model: "time",
            },
          ]
        },
        */
        {
          tag:'div',
          styleClasses: "w-full flex-none",
          fields: [{
              type:"array",
              label:"Tweens",
              model:"tweens",
              showRemoveButton: false,
              showAddButton: false,
              items: {
                type: 'object',
                tag: 'div',
                styleClasses: 'wtf',
                default: {},
                schema: {
                  fields:[
                    {
                      styleClasses: 'float-left px-0',
                      type:"label",
                      label:"Property",
                      model:"property",
                    }
                  ]
                }
              }

            }
          ]
        }
      ]
    },
    iconName:'AnimationPlay',
    props:[
      {name:'Time',key:'time'},
      {name:'Loop',key:'loop'},
      {name:'Tweens',key:'tweens'}
    ],
    createLinkTitle:createTweenLinkGrouping


  },

  {
    type:'parallaxTransform',
    text:'Parallax',
    level: ADVANCED_LEVEL,
    toplevel: true,
    hidden: true,
  },

  {
    type: 'translate',
    text: 'Translate',
    level: ADVANCED_LEVEL,
    category: categories.animations,
    description: [
      "A Translate immediately changes the position, scale, or rotation of the parent Transform."
    ].join("\n"),
    slots: ['link'],
    dataSchema: {
      fields: [
        {
          type:'toggleSwitch',
          label:'Keep?',
          model:'keep',
        },
        {
          type:'select',
          label:'Translation type',
          model:'translateType',
          values:['add', 'set', 'smooth']
        },
        {
          type:'numberOrVariable',
          label:'Smooth speed (if type = smooth)',
          model:'lerpt',
        },
        {
          type: "numberOrVariable",
          label: "X",
          model: "dx",
        },
        {
          type: "numberOrVariable",
          label: "Y",
          model: "dy",
        },
        {
          type: "numberOrVariable",
          label: "Rotation",
          model: "dr",
        },
        {
          type: "numberOrVariable",
          label: "Scale X",
          model: "dsx",
        },
        {
          type: "numberOrVariable",
          label: "Scale Y",
          model: "dsy",
        },
      ]
    }
  },

  /*
  {
    type: 'allTransforms',
    text: 'All Toys',
    description: [
      "Applies behaviours to all toys in the scene",
    ].join("\n"),
    slots: ['link']
  },
  */

  {
    type: 'script',
    text: 'Script',
    level: SUPERUSER_LEVEL,
    category: categories.scripting,
    description: [
      "Create a custom script"
    ].join("\n"),
    slots: ['link']
  },

  {
    type: 'onDestroy',
    text: 'On Destroy',
    level: ADVANCED_LEVEL,
    category: categories.behaviour,
    description: [
      "Overrides the destroy behaviour. Note: you must use the destroy Feature yourself at some point to actually destroy the toy."
    ].join("\n"),
    slots: ['link']
  },
  //{type:'uuid', text:'UUID', description:[
  //].join("\n"),slots:['link']},
  {
    type: 'log',
    text: 'Log Stat',
    level: SUPERUSER_LEVEL,
    category: categories.scripting,
    description: [
      "Log a statistic for analysis"
    ].join("\n"),
    slots: ['link']
  },
  {
    type: 'fetchTransform',
    toplevel: true,
    text: 'Fetch Transform',
    level: SUPERUSER_LEVEL,
    category: categories.scripting,
    description: [
      "Fetch Transform"
    ].join("\n"),
    hidden: true,
    slots: ['success', 'error']
  },
  {
    type: 'scrollTransform',
    toplevel: true,
    text: 'Scroll Transform',
    level: ADVANCED_LEVEL,
    category: categories.animations,
    description: [
      "Scroll Transform"
    ].join("\n"),
    hidden: true,
    slots: ['link']
  },

  {
    type: 'spineTransform',
    toplevel: true,
    hidden: true,
    text: 'Spine Transform',
    level: SUPERUSER_LEVEL,
    category: categories.animations,
    description: [
      "Spine Transform"
    ].join("\n"),
    slots: ['link']
  },
  {
    type: 'spineStart',
    text: 'Start Animation',
    level: SUPERUSER_LEVEL,
    category: categories.animations,
    description: [
      "Start Spine Animation"
    ].join("\n"),
    slots: ['link']
  },

  {
    type: 'spineStop',
    text: 'Stop Animation',
    level: SUPERUSER_LEVEL,
    category: categories.animations,
    description: [
      "Stop Spine Animation"
    ].join("\n"),
    slots: ['link']
  },

  {
    type: 'conditionalTransform',
    toplevel: true,
    text: 'Conditional Transform',
    level: ADVANCED_LEVEL,
    category: categories.scripting,
    description: [
      "Conditional Transform"
    ].join("\n"),
    hidden: true,
    slots: ['link']
  },
  {
    type: 'fetchData',
    text: 'Fetch Data',
    level: SUPERUSER_LEVEL,
    category: categories.scripting,
    description: [
      "Fetch Data from a remove API"
    ].join("\n"),
    slots: ['error', 'success']
  },
  /*
    {type:'giveScore', text:'Give Score', description:[
      "What's a game without points?"
    ].join("\n"),slots:[]},
    */
  {
    type: 'stateManager',
    text: 'State Manager',
    level: ADVANCED_LEVEL,
    category: categories.scripting,
    description: [
      "React to changes to variables."
    ].join("\n"),
    hidden: true,
    slots: ['link', 'enter', 'exit'],
    iconName: 'StateMachine'
  },
  {
    type: 'stateManagerFeature',
    text: 'State Manager',
    level: ADVANCED_LEVEL,
    category: categories.scripting,
    description: [
      "React to changes to variables."
    ].join("\n"),
    slots: (gamedata, c, data, treeutil, link) => {
      let description = `Specific Change in"${c.stateVariable.name}"`
      if (link) {
        if ( (link.meta||{}).stateType === 'variable') {
          description = `${c.stateVariable.name} -> ${link.meta.state}`;
        }
      }
      return [
        {
          name:'any',
          description:`Any Change in "${c.stateVariable.name}"`
        },
        {
          name:`change`,
          description:description,
          meta:{
            widget:'stateManager',
            script:'',
            value:''
          }
        }]

    }
  },
  {
    type: 'groupTransform',
    toplevel: true,
    text: 'Group',
    level: ADVANCED_LEVEL,
    category: categories.change,
    description: [
      "Group"
    ].join("\n"),
    hidden: true,
    slots: ['link']
  },
  /*
    {type:'leaderboard', text:'Leaderboard', description:[
      "What's a game without points?"
    ].join("\n"),hidden:true,slots:['leader','score','rank', 'link']},
    */
  {
    type: 'delayTransform',
    toplevel: true,
    text: 'After Delay',
    funky: true,
    level: ADVANCED_LEVEL,
    category: categories.change,
    createNew() {
      return {
        type: 'delayTransform'
      }
    },
    createChild() {
      return {
        transform: {
          unparent: true
        },
        vars: {
          delay: 1
        }
      }
    },
    description: [
      "Delay the creation of children toys by a time interval."
    ].join("\n"),
    hidden: false,
    slots: ['link']
  },
  {
    type: 'circle',
    text: 'Circle',
    level: ADVANCED_LEVEL,
    category: categories.create,
    description: [
      "its just a circle"
    ].join("\n"),
    hidden: true,
    slots: ['link']
  },
  {
    type: 'onEventTransform',
    toplevel: true,
    funky: true,
    category: categories.behaviour,
    text: "On Event",
    level: NOOB_LEVEL,
    description: [
      "Create when an event(s) occur."
    ].join("\n"),
    hidden: false,
    slots: ['link', 'create'],
    createNew() {
      return {
        type: 'onEventTransform'
      }
    },
    createChild() {
      return {
        transform: {
          unparent: true
        },
        vars: {
          eventName: 'myEvent'
        }
      }
    },
    iconName:'CalendarAlert',
    props:[
    ],
    createLinkTitle({name}) {
      if (name === 'link') {
        return {
          title:'When On Event Is Created',
          description:'Creates your component when the on event is created.',
          name:'link'
        }
      } else if (name === 'create') {
        return {
          title:'When On Event Spawns A Toy',
          description:'Creates your component whenever the on event creates its children.',
          name:'create'
        }
      }
    }
  },
  {
    type: 'onTimeline',
    text: 'On Timeline',
    category: categories.animations,
    level: SUPERUSER_LEVEL,
    description: [
      'Triggers when a certain point on a timeline is reached'
    ].join("\n"),
    slots: ['link']
  },
  {
    type: 'timeline',
    text: 'Start Timeline',
    level: SUPERUSER_LEVEL,
    category: categories.animations,
    description: [
      "Starts/stops/resets/seeks a timeline"
    ].join("\n"),
    slots: ['link'],
    createNew: () => {
      return {
        type: 'timeline'
      }
    },
    createLinkTitle({name}) {
      return {
        title:'Activate at a time',
        description:'Creates your component after a certain amount of time',
        name:'link'
      }
    }
  },
  {
    type: 'setTransformProperties',
    text: 'Transform Properties',
    category: categories.scripting,
    level: ADVANCED_LEVEL,
    description: [
      "Set some properties on the transform"
    ].join("\n"),
    slots: []
  },
  {
    type: 'removeComponentFromToy',
    text: 'Remove Component',
    category: categories.change,
    level: ADVANCED_LEVEL,
    iconName:'Close',
    props:[
    ],
    description: [
      "Remove a component from this toy"
    ].join("\n"),
    slots: ['remove'],
    createLinkTitle:createNoLinkGrouping,
    dataSchema: {
      fields: [
        {
            type: "stringOrVariable",
            label: "Component Type Name",
            model: "component",
        }
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
            displayValueOrVariable: "label",
            label: "Component Type",
            model: "component",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'removeComponentFromToy',
        component: ''
      }
    }
  },
  {
    type: 'repeater',
    text: 'Repeater',
    category: categories.change,
    level: NOOB_LEVEL,
    description: [
      "A Repeater repeatdedly spawns its connected components at a specified time interval."
    ].join("\n"),
    slots: ['link'],
    dataSchema:{
      fields:[
        {
          type: "numberOrVariable", label: "Initial Delay", model: "initialDelay",
        },
        {
          type: "numberOrVariable", label: "Repeat Delay", model: "firetime",
        },
        {
          type: "numberOrVariable", label: "Probability to fire (0-1)", model: "probability",
        },
        {
          type: "numberOrVariable", label: "Number of times to fire (0=infinite)", model: "times",
        },
        {
          type: "numberOrVariable", label: "Pre-spawn number", model: "preSpawn",
        },
      
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type: "displayValueOrVariable", inputType: "number", unit: "seconds", label: "Repeat Delay", model: "firetime",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'repeater',
        initialDelay: 0,
        firetime: 1,
        probability: 1,
        times: 0,
        preSpawn: 0
      }
    },
    iconName:'Repeat',
    props:[
      {name:'Delay', key:'firetime'},
      {name:'Times', key:'times'},
    ],
    createLinkTitle:createDefaultLinkGrouping("When Repeater Fires", "Creates your components regularly on a timer.")
  },
  {
    type: 'askInput',
    text: 'User Input',
    level: SUPERUSER_LEVEL,
    category: categories.scripting,
    description: [
      "Promps the user for input"
    ].join("\n"),
    slots: ['isValid', 'notValid']
  },
  {
    type: 'randomTransform',
    text: "Randomly Choose",
    description: "Selects a random child toy to add to the scene.",
    level: NOOB_LEVEL,
    category: categories.change,
    toplevel: true,
    hidden: false,
    funky: true,
    slots: ['link'],
    createNew() {
      return {
        type: 'randomTransform'
      }
    },
    createChild: () => {
      return {
        transform: {
          unparent: true
        },
        vars: {
          weight: 1,
        }
      }
    },
    iconName:'Repeat',
    props:[
      {name:'Weight', key:'weight'},
    ],
    createLinkTitle:createDefaultLinkGrouping("When Random Is Created", "Immediately")
  },

  {
    type: 'unparent',
    text: 'Unparent',
    description: 'Detaches this toy from its parent, making it able to move, rotate and scale on its own.',
    level: NOOB_LEVEL,
    category: categories.change,
    slots: ['link'],
    createNew() {
      return {
        type: 'unparent'
      }
    },
    createLinkTitle({name}) {
      if (name === 'link') {
        return {
          title:'When The Toy Is Unparented',
          description:'Creates your component as soon as the toy is detached from its parent',
          name:'link'
        }
      }
    }
  },

  {
    type: 'spawner',
    text: 'Repeatedly',
    description: "Add children toys repeatedly on a timer.",
    level: NOOB_LEVEL,
    category: categories.change,
    toplevel: true,
    hidden: false,
    funky: true,
    slots: ['link', 'create'],
    createNew() {
      return {
        type: 'spawner'
      }
    },
    createChild: () => {
      return {
        transform: {
          unparent: true
        },
        vars: {
          initialDelay: 1,
          firetime: 1,
          times: 0,
          probability: 1
        }
      }
    },
    iconName:'Repeat',
    props:[
      {name:'Delay', key:'firetime'},
      {name:'Times', key:'times'},
    ],

    createLinkTitle({name}) {
      if (name === 'link') {
        return {
          title:'When Spawner Is Created',
          description:'Creates your component when the spawner is created.',
          name:'link'
        }
      } else if (name === 'create') {
        return {
          title:'When Spawner Spawns A Toy',
          description:'Creates your component whenever the spawner creates its children.',
          name:'create'
        }
      }
    }

//function createCollisionWithLinkGrouping({name}) {
  },
  //{type:'createEntity', text:'Create Toy', description:[
  //"Create Toy creates a new Toy from its connected components."
  //].join("\n"),slots:['link']},
  {
    type: 'toy',
    text: 'Create Toy',
    category: categories.create,
    hidden: true,
    level: ADVANCED_LEVEL,
    createNew: () => {
      return {
        type: 'toy',
        tid: ''
      }
    },
    description: [
      "Create Toy creates a new Toy"
    ].join("\n"),
    slots: (gamedata, c, data, treeutil) => {
      return [];
      if (!treeutil) {
        throw new Error('pass treeutil');
      }
      const myToy = gamedata.toybox.filter((f) => {
        return f.id === c.tid;
      })[0];

      const flattenedChildren = treeutil.flattenChildren(myToy)
      const toyComponents = flattenedChildren.map((t) => {
        return treeutil.findComponentById(t.cid);
      });

      const components = uniqBy(flatten(
        toyComponents.map((c) => {
          return treeutil.getAllComponentsFrom(data, c)
        })
      ), (x) => {
        return x.id;
      });

      return components.filter((c) => {
        return c.type === 'slot';
      }).map((c) => {
        return {
          name: c.slotName,
          description: c.slotName,
          meta: {
            linkName: c.slotName,
            cid: c.id
          }
        }
      }).concat(['link']);


      return ['link'];
      const interestingComponentTypes = ['feature', 'createEntity', 'toy', 'prefab', 'multiple'];
      const visited = {};

      function getLinkingComponents(from) {
        if (visited[from.id]) {
          return [];
        }
        visited[from.id] = true;
        const allLinks = treeutil.getAllComponentsFrom(data, from);
        const interesting = allLinks.filter((c) => {
          return includes(interestingComponentTypes, c.type);
        });
        const expandedComponents = interesting.filter((c) => {
          return c.toy;
        }).map((c) => {
          return getLinkingComponents({
            id: c.toy
          });
        })
        return [from].concat(flatten(expandedComponents.concat(interesting))).filter((c) => {
          return c.type
        });
      }


      const toyComponent = treeutil.findComponentById(c.toy);

      let links = [toyComponent].concat(getLinkingComponents({
        id: c.toy
      }));
      links = uniq(links, (c) => {
        return c.id;
      });
      return links.map((c) => {
        return {
          type: c.type,
          name: c.id,
          description: c.name,
          meta: {
            linkName: 'link'
          }
        }
      });
      return uniq([toyComponent].concat(treeutil.getAllComponentsFrom(data, {
        id: c.toy
      })), (c) => {
        return c.id
      })

        .filter((c) => {
          return c.type === 'slot';
        })
        .map((c) => {
          return {
            name: c.id,
            description: c.name,
            meta: {
              linkName: 'link'
            }
          }
        })

    },
    iconName:'ToyBrick',
    props:[
      {name:'Toy',key:'tid'}
    ],
    createLinkTitle:createDefaultLinkGrouping("When Toy Is Created", "Creates your components as soon as the toy is created.")
  },

  {
    type: 'feature',
    text: 'Feature',
    category: categories.scripting,
    description: '',
    hidden: true,
    level: SUPERUSER_LEVEL,
    slots: (gamedata, c, partutil, transform) => {

      if (c.__builtin) {
        return [];
      }

      console.log('gamedata', gamedata);
      console.log('c', c);
      console.log('partutil', partutil);

      const myFeature = (partutil.gamedata.features||[]).filter((f) => {
        return f.id === c.fid;
      })[0];

      if (!myFeature) {
        console.warn('could not find feature', c.fid);
        return [];
      }

      console.log('myFeature', myFeature);

      const {
        components,
        links,
        root
      } = myFeature;

      return components.filter((c) => {
        return c.type === 'slot';
      }).map((c) => {
        return {
          name: c.slotName,
          description: c.slotName,
          meta: {
            linkName: c.slotName,
            cid: c.id
          }
        }
      }).concat(['link']);
    }
  },

  {
    type: 'video',
    text: 'Video',
    category: categories.create,
    level: NOOB_LEVEL,
    description: [
      "Play a Video from the gallery or upload your own."
    ].join("\n"),
    toplevel: true,
    showInComponentView: false,
    slots: ['link'],
    dataSchema: {
      fields: [
        {
          type: 'video',
          model: 'video',
          enableGallery: true,
          styleClasses: 'sprite-wrap',
          validator: [spriteValidator],
          required: true
        }
      ]
    },
    condensedSchema: {
      fields: [
        {
          type: 'video',
          model: 'video',
          label: '',
          spriteSize: 20
        }
      ]
    },
    createNew: () => {
      return {
        type: 'video',
        video: 'placeholder.mp4',
        thumbnail: 'placeholder.mp4.png',
        width:512,
        height:512,
      }
    },
    iconName:'Image',
    createLinkTitle:createDefaultLinkGrouping("When Video Is Added", "Creates your components as soon as the video has been added to the scene.")
  },
  {
    type: 'sprite',
    text: 'Image',
    category: categories.create,
    level: NOOB_LEVEL,
    description: [
      "Show an image in the scene, by uploading your own or selecting from the gallery."
    ].join("\n"),
    toplevel: true,
    showInComponentView: false,
    slots: ['link'],
    dataSchema: {
      fields: [
        {
          type: 'sprite',
          model: 'sprite',
          enableGallery: true,
          styleClasses: 'sprite-wrap',
          validator: [spriteValidator],
          required: true
        }
      ]
    },
    condensedSchema: {
      fields: [
        {
          type: 'sprite',
          model: 'sprite',
          label: '',
          spriteSize: 20
        }
      ]
    },
    createNew: () => {
      return {
        type: 'sprite',
        sprite: 'placeholder.png'
      }
    },
    iconName:'Image',
    props:[
      {name:'Sprite',key:'prop'}
    ],
    createLinkTitle:createDefaultLinkGrouping("When Sprite Is Added", "Creates your components as soon as the sprite has been added to the scene.")
  },
  {
    type: 'spriteMask',
    text: 'Mask',
    level: NOOB_LEVEL,
    category: categories.behaviour,
    description: [
      "Mask with another"
    ].join("\n"),
    slots: [
    ],
    iconName:'ArrowCollapseRight',
    props:[
      {name:'With', key:'tags'},
    ],
    dataSchema: {
      fields: [
          {
            label:"Collide With",
            model:"maskTransformIds",
            type:"chooseTransformsByComponentType",
            componentTypes: ['sprite', 'primitive', 'text', 'video'],
            selectionType: "tid"
          }
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type:"showTransformsByTid",
          label:"Target(s)",
          model:'maskTransformIds',
          filterComponentTypes: ['sprite', 'primitive', 'text', 'video']
        },
      ]
    },
    createNew:() => {
      return {
        type:'spriteMask',
        maskTransformIds: [],
      }
    },
    createLinkTitle:createDefaultLinkGrouping("After Mask is Added", "Create after mask is added")
  },

  /*
    {type:'spriteMask', text:'Sprite Mask', description:[
      'Apply a mask to the sprite. A mask determines where the sprite is visible/hidden'
    ].join("\n"),slots:['link']},
    */
  {
    type: 'collisionWith',
    text: 'Collide Action',
    level: NOOB_LEVEL,
    category: categories.behaviour,
    description: [
      "What happens when this toy collides with anothert type of toy?"
    ].join("\n"),
    /*
      {
        name:'link',
        description:'Pointer Down Repeat'
      },
      */

    slots: [
      {
        name:'begin',
        title:'Collision Begins',
        description:'Activates when the two toys start touching.'
      },
      {
        name:'end',
        title:'Collision Ends',
        description:'Activates when the two toys stop touching.'
      },
      {
        name:'beginOther', 
        title:'Collision Begins (Other)',
        description:'Activates on the other toy when the two toys start touching.'
      },
      {
        name:'endOther',
        title:'Collision Ends (Other)',
        description:'Activates on the other toy when the two toys stop touching.'
      },
      {
        name:'busy',
        title:'Collision Busy',
        description:'Activates on the toy for every frame while the two toys are touching'
      },
      {
        name:'busyOther',
        title:'Collision Busy (Other)',
        description:'Activates on the other toy for every frame while the two toys are touching'
      },
    ],
    iconName:'ArrowCollapseRight',
    props:[
      {name:'With', key:'tags'},
    ],
    dataSchema: {
      fields: [
          {
            label:"Collide With",
            model:"tags",
            type:"chooseOrCreateCollisionBox",
            componentTypes: ['physicsbody2d', 'collisionBox']
          },
          {
            type: "checkbox",
            label: "Once Only",
            model: "onceOnly",
          },
          {
            type: "checkbox",
            label: "Once Only Per Toy",
            model: "onceOnlyTag",
          },
          {
            type: "stringOrVariable",
            label: "Collide With Tags",
            model: "specialTags",
          },
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type:"showTransformsByCid",
          label:"Target(s)",
          model:'tags',
          filterComponentTypes: ['physicsbody2d', 'collisionBox']
        },
      ]
    },
    createNew:() => {
      return {
        type:'collisionWith',
        tags: [],
        onceOnlyTag: false,
        onceOnly: false,
        scalex: 1,
        scaley: 1,
        specialTags: ''
      }
    },
    createLinkTitle:createCollisionWithLinkGrouping
  },
  {
    type: 'collisionBox',
    text: 'Collision Box',
    level: NOOB_LEVEL,
    category: categories.behaviour,
    description: [
      "CollisionBox makes this Toy available for collision detection"
    ].join("\n"),
    slots: [],
    iconName:'ArrowCollapseRight',
    props:[
      {name:'With', key:'tags'},
    ],
    createLinkTitle:createCollisionWithLinkGrouping,
    dataSchema: {
      fields: [
          {
            type: "stringOrVariable",
            label: "Tag",
            model: "tag",
          },
          {
            type: "numberOrVariable",
            label: "Scale X",
            model: "scalex",
          },
          {
            type: "numberOrVariable",
            label: "Scale Y",
            model: "scaley",
          },
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type: "displayValueOrVariable",
          label: "Tag",
          model: "tag",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'collisionBox',
        scalex: 1,
        scaley: 1,
        tag: ''
      }
    }
  },
  /*
    {type:'collisionLayers', text:'Collisions', description:[
      "What happens when two things collide? A game is nothing without consequences to user action!"
    ].join("\n"),slots:(c) => { return [c.layerA, c.layerB]}},
    */
  {
    type: 'setgamestate',
    text: 'Set Game State',
    iconName: 'HelpCircle',
    level: NOOB_LEVEL,
    category: categories.scripting,
    description: [
      "Set Game State sets the game state to either 'win' or 'lose'."
    ].join("\n"),
    slots: [],
    props: [
    ],
    dataSchema: {
      fields: [
        {
          type:"select",
          label: "Game State",
          model: "state",
          values:[
            {name:'Win!',id:'win'},
            {name:'Game Over',id:'gameover'},
            {name:'Restart',id:'restart'},
          ]
        },
        {
          type: 'stringOrVariable',
          model: 'message',
          label: 'Message'
        },
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type: "displayValueOrVariable", label: "Game State", model: "state",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'setgamestate',
        message: '',
        state: 'restart'
      }
    },
    createLinkTitle:createDefaultLinkGrouping("LOL")
  },
  {
    type: 'setstate',
    text: 'Set Toy State',
    level: SUPERUSER_LEVEL,
    category: categories.scripting,
    description: [
      'Set the state of the toy',
    ].join("\n"),
    slots: []
  },
  {
    type: 'automove',
    text: 'Auto Move',
    category: categories.animations,
    level: NOOB_LEVEL,
    description: [
      "AutoMove makes the toy continiously move in a certain direction."
    ].join("\n"),
    slots: ['link'],
    createNew: () => {
      return {
        type: 'automove',
        dx: 1,
        dy: 1
      }
    },
    dataSchema: [
      {
        predicate: (data) => { return !data.respectRotation },
        fields:[
          {
            type: "checkbox",
            label: "Respect Rotation",
            model: "respectRotation",
          },
          {
            type: "numberOrVariable",
            label: "X",
            model: "dx",
          },
          {
            type: "numberOrVariable",
            label: "Y",
            model: "dy",
          },
        ]
      },
      {
        predicate: (data) => { return data.respectRotation },
        fields:[
          {
            type: "checkbox",
            label: "Respect Rotation",
            model: "respectRotation",
          },
          {
            type: "numberOrVariable",
            label: "Speed",
            model: "dy",
          },
        ]
      }
    ],
    condensedSchema: [
      {
        predicate: (data) => { return !data.respectRotation },
        tag: 'div',
        fields:[
          {
            type: "displayValueOrVariable",
            inputType: "number",
            label: "X",
            model: "dx",
          },
          {
            type: "displayValueOrVariable",
            inputType: "number",
            label: "Y",
            model: "dy",
          },
        ]
      },
      {
        predicate: (data) => { return data.respectRotation },
        tag: 'div',
        fields:[
          {
            type: "displayValueOrVariable",
            label: "Speed",
            model: "dy",
          },
        ]
      }
    ],
    iconName:'SwapHorizontal',
    props:[
      {name:'X',key:'dx'},
      {name:'Y',key:'dy'}
    ],
    createLinkTitle:createDefaultLinkGrouping("When Automove Is Created", "Creates your components as soon as the automove is applied to the toy.")
  },
  {
    type: 'path',
    hidden: true,
    text: 'internal',
    level: ADVANCED_LEVEL,
    category: categories.animations,
    description: [
      ""
    ].join("\n"),
    slots: ['link']
  },
  {
    type: 'point',
    hidden: true,
    text: 'internal',
    level: ADVANCED_LEVEL,
    category: categories.create,
    description: [
      ""
    ].join("\n"),
    slots: ['link']
  },
  {
    type: 'emitEvent',
    text: 'Emit Event',
    level: NOOB_LEVEL,
    category: categories.behaviour,
    description: [
      "Emits an event using the name provided."
    ].join("\n"),
    slots: ['link'],
    dataSchema: {
      fields: [
        {
          type: "eventsSelector", label: "Event To Emit", model: "eventName", default:''
        },
        {
          type: "checkbox", label: "Local Only?", model: "localEvent", default:''
        },
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
            type: "displayValueOrVariable",
            inputType: "event",
            label: "Event",
            model: "eventName",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'emitEvent',
        localEvent: false,
        eventName: 'myEvent'
      }
    },
    iconName:'CalendarBlank',
    props:[
      {name:'Event',key:'eventName'}
    ],
    createLinkTitle:createDefaultLinkGrouping("After Event Fired", "Creates your feature immediately after firing the event.")
  },
  {
    type: 'onEvent',
    text: 'On Event',
    level: NOOB_LEVEL,
    category: categories.behaviour,
    description: [
      "Triggers whenever the given event is emitted by onEvent."
    ].join("\n"),
    slots: ['link'],
    dataSchema: {
      fields: [
        {
          type: "eventsSelector", label: "Event To Wait For", model: "eventName", default:''
        },
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type: "displayValueOrVariable",
          inputType: "event",
          label: "Event",
          model: "eventName",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'onEvent',
        eventName: 'myEvent'
      }
    },
    iconName:'CalendarAlert',
    props:[
      {name:'Event',key:'eventName'}
    ],
    createLinkTitle:createDefaultLinkGrouping("When Event Fired", "Creates your feature as soon as the event is fired.")
  },

  {
    type: 'destroy',
    text: 'Destroy',
    limitedMode: true,
    level: NOOB_LEVEL,
    category: categories.change,
    description: [
      "Destroys the attached Toy."
    ].join("\n"),
    slots: [],
    props:[
    ],
    dataSchema: {
      fields: [
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
      ]
    },
    createNew: () => {
      return {
        type: 'destroy'
      }
    },
    iconName:'CloseCircle',
    createLinkTitle:createNoLinkGrouping
  },
  {
    type: 'multiple',
    text: 'Group',
    category: categories.change,
    level: ADVANCED_LEVEL,
    description: [
      "Use this component to link a bunch of components to a single component. This is mostly used for visual grouping on the canvas."
    ].join("\n"),
    slots: ['link'],
    props:[
    ],
    dataSchema: {
      fields: [
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
      ]
    },
    createNew: () => {
      return {
        type: 'multiple',
        keep: true
      }
    },
    createLinkTitle:createDefaultLinkGrouping("When Group Is Added", "Creates your feature as soon as the group is created.")
  },
  /*
    {type:'prefab', text:'Group', description:[
      "Toy box",
    ].join("\n"),slots:['link']},
    */
  /*
    {type:'properties', text:'Property Holder', description:[
      "Gives this toy a name in the Properties section of the game."
    ].join("\n"),slots:[]},
    */
  {
    type: 'setproperties',
    text: 'Set Properties',
    level: NOOB_LEVEL,
    category: categories.scripting,
    description: [
      "Sets a property for this toy in the Properties section of the game."
    ].join("\n"),
    slots: ['link'],
    dataSchema:{
      fields:[{
            type:"array",
            label:"Changes To Make",
            model:"properties",
            showRemoveButton: true,
            items: {
              type: 'object',
              default: {},
              schema: {
                fields:[
                  {
                    type: "stringOrVariable",
                    label: "name",
                    model: "name"
                  },
                  {
                    type: "numberOrVariable",
                    label: "value",
                    model: "value"
                  },
                ]
              }
            }
        }
      ]
    },
    iconName: 'Pencil',
    createNew() {
      return {
        type: 'setproperties',
        properties: []
      }
    },
    createLinkTitle:createBySlotNameLinkGrouping('Set Properties')
  },
  {
    type: 'changeproperties',
    text: 'Change Properties',
    category: categories.scripting,
    level: NOOB_LEVEL,
    description: [
      "Change a property of this toy by a certain amount/value in the Properties section of the game."
    ].join("\n"),
    slots: ['link'],
    dataSchema:{
      fields:[{
            type:"array",
            label:"Changes To Make",
            model:"properties",
            showRemoveButton: true,
            items: {
              type: 'object',
              default: {},
              schema: {
                fields:[
                  {
                    type: "stringOrVariable",
                    label: "name",
                    model: "name"
                  },
                  {
                    type: "numberOrVariable",
                    label: "value",
                    model: "value"
                  },
                ]
              }
            }
        }
      ]
    },
    iconName: 'PencilPlus',
    createNew: () => {
      return {
        type: 'changeproperties',
        properties:[]
      }
    },
    props:[
    ],
    createLinkTitle:createBySlotNameLinkGrouping('Change Properties')

  },
  {
    type: 'limitProperties',
    text: 'Limit Properties',
    category: categories.scripting,
    level: NOOB_LEVEL,
    description: [
      "Limits a property or properties between two values"
    ].join("\n"),
    slots: ['link'],
    dataSchema:{
      fields:[{
            type:"array",
            label:"Limits",
            model:"properties",
            showRemoveButton: true,
            items: {
              type: 'object',
              default: {},
              schema: {
                fields:[
                  {
                    type: "stringOrVariable",
                    label: "name",
                    model: "name"
                  },
                  {
                    type: "numberOrVariable",
                    label: "Minimum",
                    model: "minimum"
                  },
                  {
                    type: "numberOrVariable",
                    label: "Maximum",
                    model: "maximum"
                  },
                  {label:'Limit at Minimum',type:'toggleSwitch',model:'limitMinimum',default:true},
                  {label:'Limit at Maximum',type:'toggleSwitch',model:'limitMaximum',default:true},
                  {label:'Wrap Maximum to Minimum',type:'toggleSwitch',model:'wrapMaximum',default:true},
                  {label:'Wrap Minimum to Maximum',type:'toggleSwitch',model:'wrapMinimum',default:true},
                ]
              }
            }
        }
      ]
    },

    createNew: () => {
      return {
        type: 'limitProperties',
        properties:[]
      }
    },
    props:[],
    createLinkTitle:createBySlotNameLinkGrouping('Limit Properties')
  },
  {type:'goal', text:'Goal', 
    level: ADVANCED_LEVEL,
    category: categories.scripting,
  description:[
    "A game needs a goal. Checks the value of a variable."
  ].join("\n"),slots:[]},
  {
    type: 'followpath',
    text: 'Follow Path',
    level: SUPERUSER_LEVEL,
    category: categories.animations,
    description: [
      "The Toy will follow a certain Path that you can draw on the Canvas."
    ].join("\n"),
    slots: (gamedata, c) => {
      let standard = ['begin', 'finish'];
      return standard.concat(
        flatten(range(c.curves.length).map((i) => {
          if (c.flip) {
            return [
              'forward-start-curve-' + i,
              'forward-finish-curve-' + i,
              'backward-start-curve-' + i,
              'backward-finish-curve-' + i,
            ]
          } else {
            return ['start-curve-' + i, 'finish-curve-' + i]
          }
        }))
      )
    }
  },
  /*
    {type:'target', text:'Target Entity', description:[
      "Apply all linked Components to a different Entity than the one attached to."
    ].join("\n"),slots:['link']},
    */
  {
    type: 'tapcontroller',
    text: 'Tap Controller',
    limitedMode: true,
    level: NOOB_LEVEL,
    category: categories.input,
    description: [
      "Do something when the user Taps his phone or Clicks on the screen."
    ].join("\n"),
    slots: [
      {
        name:'busy',
        description:'Pointer Down Repeat'
      },
      {
        name:'start',
        description:'Pointer Down'
      }, {
        name:'finish',
        description:'Pointer Up'
      }],

    dataSchema :({component}) => {
      return {
        fields:compact([
          !component.tapAnywhere ? {
            label:'Scale X',type:'numberOrVariable',model:'scalex'
          } : undefined,
          !component.tapAnywhere ? {
            label:'Scale Y',type:'numberOrVariable',model:'scaley'
          } : undefined,
          {
            label:'Tap Anywhere',type:'toggleSwitch',model:'tapAnywhere'
          },
          {
            label:'Repeat Enabled',type:'toggleSwitch',model:'repeatEnabled'
          },
          {
            label:'Cooldown Time',type:'numberOrVariable',model:'cooldown'
          },
          {
            label:'Cooldown Event',type:'eventsSelector',model:'cooldownEvent'
          },
          {
            label:'Cooldown Key',type:'stringOrVariable',model:'cooldownKey'
          }
        ])
      }
    },
    condensedSchema: {
      fields: [
          {
            label:'Tap Anywhere',type:'displayValueOrVariable',inputType:"boolean",model:'tapAnywhere'
          },
      ]
    },
    createNew: () => {
      return {
        type: 'tapcontroller',
        scalex: 1,
        scaley: 1,
        repeatEnabled: false,
        cooldown: 0,
        cooldownEvent: '',
        cooldownKey: ''
      }
    },
    iconName:'GestureTap',
    props:[
    ],
    createLinkTitle:createTapControllerLinkGrouping
  },
  {
    type: 'jump',
    text: 'Jump',
    hidden: true,
    category: categories.animation,
    description: [
      "Make this Toy Jump in a certain direction. After Jumping, the Toy will be dragged down by Gravity if the Gravity Affected component is also attached."
    ].join("\n"),
    slots: ['link']
  },
  {
    type: 'randomChoose',
    text: 'Random Activate',
    level: NOOB_LEVEL,
    category: categories.change,
    description: [
      "Randomly activate attached components depending on the configured probability."
    ].join("\n"),
    createNew:() => {
      return {
        type: 'randomChoose',
      }
    },
    slots: ['link'],
    createLinkTitle({name}) {
      if (name === 'link') {
        return {
          title:'Randomly Choose One',
          description:'Randomly chooses one of the features to activate',
          name:'link'
        }
      }
    }

  },
  //{type:'flippath', text:'Flip Path', description:[
  //].join("\n"),slots:['link']},
  {
    type: 'moveto',
    text: 'Move To',
    level: SUPERUSER_LEVEL,
    category: categories.animations,
    description: [
      "Move this Toy to a certain position on the Canvas."
    ].join("\n"),
    slots: ['start', 'finish']
  },
  {
    type: 'move',
    text: 'Move',
    limitedMode: true,
    level: NOOB_LEVEL,
    category: categories.animations,
    description: [
      "Move this Toy in a delta direction."
    ].join("\n"),
    slots: ['start', 'finish'],
    dataSchema: {
      fields: [
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "Change in X",
          model: "dx",
        },
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "Change in Y",
          model: "dy",
        },
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "Duration",
          model: "t",
        },
        {
          type: "tween-select",
          label: "Tween",
          model: "tween",
        },
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "X",
          model: "dx",
        },
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "Y",
          model: "dy",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'move',
        dx: 1,
        dy: 1,
        t: 1,
        tween: 'linear'
      }
    },
    iconName:'CursorMove',
    props:[
      {name:'X',key:'dx'},
      {name:'Y',key:'dy'}
    ],
    createLinkTitle:createBySlotNameLinkGrouping('Move')
  },
  {
    type: 'swipecontroller',
    text: 'Swipe Controller',
    level: NOOB_LEVEL,
    category: categories.input,
    description: [
      "Activate components when the user swipes on his phone"
    ].join("\n"),
    slots: [{
      type: 'any',
      name: 'any',
      description: 'Any Direction'
    },
      {
        type: 'horizontal',
        name: 'horizontal',
        description: 'Horizontal'
      },
      {
        type: 'vertical',
        name: 'vertical',
        description: 'Vertical'
      },
      {
        type: 'left',
        name: 'left',
        description: 'Left'
      },
      {
        type: 'right',
        name: 'right',
        description: 'Right'
      },
      {
        type: 'up',
        name: 'up',
        description: 'Up'
      },
      {
        type: 'down',
        name: 'down',
        description: 'Down'
      },
    ],
    dataSchema: {
        fields:[
          /*
          {
            type: "numberOrVariable",
            label: "Change in X",
            model: "lerpx",
          },
          {
            type: "numberOrVariable",
            label: "Change in Y",
            model: "lerpy",
          },
          {
            type: "numberOrVariable",
            label: "Velocity",
            model: "velocity",
          },
          */
        ]
    },
    condensedSchema: {
      fields: [
      ]
    },
    createNew: () => {
      return {
        type: 'swipecontroller',
        lerpx: 0,
        lerpy: 0,
        velocity: 0
      }
    },
    iconName:'GestureSwipe',
    props:[
    ],
    createLinkTitle:createSwipeControllerLinkGrouping

  },
  {
    type: 'keycontroller',
    text: 'Key Controller',
    level: ADVANCED_LEVEL,
    category: categories.input,
    description: [
      "Activate components when the user presses a key on his keyboard."
    ].join("\n"),
    slots: ['enter key name'],
    iconName: 'Keyboard',
    dataSchema: {
    },
    props:[
    ],
    createLinkTitle:createSwipeControllerLinkGrouping
  },
  {
    type: 'primitive',
    text: 'Draw Shape',
    level: NOOB_LEVEL,
    category: categories.create,
    hidden: false,
    toplevel: true,
    description: [
      "Draw a primitive shape, like a rectangle or a circle."
    ].join("\n"),
    slots: ['link'],
    createNew: () => {
      return {
        type: 'primitive',
        color: '0xffffff',
        stroke: '0xffffff',
        lineWidth: 1,
        shapetype: 'rectangle',
        scalex: 1,
        scaley: 1
      }
    },
    dataSchema: {
      fields: [
        {
          type:"select",
          label:"Shape",
          model:"shapetype",
          values:[
            {name:'Rectangle',id:'rectangle'},
            {name:'Circle',id:'circle'},
          ]
        },
        {
            type: "color",
            label: "Fill Color",
            model: "color",
        },
        {
            type: "color",
            label: "Stroke Color",
            model: "stroke",
        },
        {
            type: "numberOrVariable",
            label: "Line Width",
            model: "lineWidth",
        },
        {
            type: "numberOrVariable",
            label: "Scale X",
            model: "scalex",
        },
        {
            type: "numberOrVariable",
            label: "Scale Y",
            model: "scaley",
        },
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
            type: "displayValueOrVariable",
            inputType: "color",
            label: "Fill Color",
            model: "color",
        }
      ]
    },
    iconName:'Drawing',
    props:[
    ],

    createLinkTitle:createDefaultLinkGrouping("When Shape Is Added", "Creates your feature as soon as the shape has been added to the scene.")
  },

  {
    type: 'stopmovement',
    text: 'Stop Movement',
    level: ADVANCED_LEVEL,
    category: categories.animations,
    description: [
      "Immediately stop moving this Toy."
    ].join("\n"),
    slots: ['link'],
    props: [
    ],
    iconName: 'HelpCircle',
    createLinkTitle: createDefaultLinkGrouping("When Movement Is Stopped", "Creates your feature as soon as all movement has been stopped on the toy."),
    createNew: () => {
      return {
        type: 'stopmovement',
      }
    },
    dataSchema: {
      fields: [
        {
            type: "toggleSwitch",
            label: "Revert To Start",
            model: "revertToStart",
        }
      ]
    },
    condensedSchema: {
      fields: [
        {
          type: 'label',
          model: 'revertToStart',
          label: 'Revert To Start'
        }
      ]
    },
  },
  {
    type: 'cooldown',
    text: 'Cooldown',
    level: ADVANCED_LEVEL,
    category: categories.change,
    description: [
      "Block all attached components from activating within a certain cool-down period."
    ].join("\n"),
    slots: ['link'],
    iconName: 'TimerOff',
    props:[
    ],
    createLinkTitle: createDefaultLinkGrouping('After Cooldown', "Creates your component only when the cooldown timer is cleared.")
  },
  {
    type: 'delay',
    text: 'Delay',
    limitedMode: true,
    level: NOOB_LEVEL,
    category: categories.change,
    description: [
      "Activate all attached components after a specified delay."
    ].join("\n"),
    slots: ['link'],
    dataSchema: {
      fields: [
        {
            type: "numberOrVariable",
            inputType: "number",
            label: "Delay in seconds",
            model: "delay",
        }
      ]
    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type: "displayValueOrVariable",
          inputType: "number",
          unit: "seconds",
          label: "Delay",
          model: "delay",
        },
      ]
    },
    createNew: () => {
      return {
        type: 'delay',
        delay: 1
      }
    },
    iconName:'Alarm',
    props:[
      {name:'Delay',key:'delay'}
    ],
    createLinkTitle:createDefaultLinkGrouping("When Delay Is Finished", "Creates your feature as soon as the delay in time has elapsed.")
  },

  {
    type: 'press',
    text: 'Press Controller',
    level: ADVANCED_LEVEL,
    category: categories.input,
    description: [
      "Fire components depending on where the user taps or clicks relative to the Toy, for example left or right, up or down."
    ].join("\n"),
    slots: ['left', 'right', 'top', 'bottom']
  },

  {
    type: 'pan',
    text: 'Pan Controller',
    level: ADVANCED_LEVEL,
    category: categories.input,
    description: [
      "Fire components depending on where the user pans relative to the Toy, for example left or right, up or down."
    ].join("\n"),
    slots: [{
      type: 'any',
      name: 'any',
      description: 'Any Direction'
    },
      {
        type: 'horizontal',
        name: 'horizontal',
        description: 'Horizontal'
      },
      {
        type: 'vertical',
        name: 'vertical',
        description: 'Vertical'
      },
      {
        type: 'left',
        name: 'left',
        description: 'Left'
      },
      {
        type: 'right',
        name: 'right',
        description: 'Right'
      },
      {
        type: 'top',
        name: 'top',
        description: 'Up'
      },
      {
        type: 'bottom',
        name: 'bottom',
        description: 'Down'
      },
      {
        type: 'anyStart',
        name: 'anyStart',
        description: 'Start (Any Direction)'
      },
      {
        type: 'anyEnd',
        name: 'anyEnd',
        description: 'End (Any Direction)'
      },

    ]
  },


  {
    type: 'playSound',
    text: 'Play Sound',
    level: ADVANCED_LEVEL,
    category: categories.animations,
    description: [
      "Play a sound on the users' device."
    ].join("\n"),
    slots: ['link'],
    iconName:'VolumeHigh',
    props:[
      {name:'Sound', key:'sound'}
    ],
    createLinkTitle:createDefaultLinkGrouping("After Sound Starts", "Creates your component as soon as the sound has started playing.")
  },
  {
    type: 'tiledSprite',
    toplevel: true,
    text: 'Tiled Sprite',
    level: NOOB_LEVEL,
    category: categories.create,
    showInComponentView: false,
    createNew: () => {
      return {
        type: 'tiledSprite',
        sprite: 'placeholder.png',
        offsetx: 0,
        offsety: 0,
        parallaxx: 1,
        parallaxy: 1,
        lockToCamera: true,
        sizex: 1,
        sizey: 1,
        basesizex: -1,
        basesizey: -1

      }
    },
    description: [
      "Tile the attached sprite on the full dimensions of the Transform."
    ].join("\n"),
    slots: ['link'],
    dataSchema: {
      fields: [
        {
          type: 'sprite',
          model: 'sprite',
          enableGallery: true,
          styleClasses: 'sprite-wrap',
          validator: [spriteValidator],
          required: true
        }
      ]
    },
    condensedSchema: {
      fields: [
        {
          type: 'sprite',
          model: 'sprite',
          label: '',
          spriteSize: 20
        }
      ]
    },
    createLinkTitle:createDefaultLinkGrouping("When Sprite Is Added", "Creates your components as soon as the sprite has been added to the scene.")
  },
  {
    type: 'restrictPosition',
    text: 'Restrict Position',
    level: NOOB_LEVEL,
    category: categories.behaviour,
    description: [
      "Restricts the Toys' position to be inside a certain boundary."
    ].join("\n"),
    slots: ['any', 'left', 'right', 'top', 'bottom'],
//function createRestrictPositionGrouping({name}) {
    createLinkTitle:createRestrictPositionGrouping,
    createNew: () => {
      return {
        type: 'restrictPosition',
        minX:-9/2,
        maxX:9/2,
        minY:-16/2,
        maxY:16/2
      }
    },
    dataSchema: {
      fields: [
        {
          type: 'numberOrVariable',
          model: 'minX',
          label: 'Min X'
        },
        {
          type: 'numberOrVariable',
          model: 'maxX',
          label: 'Max X'
        },
        {
          type: 'numberOrVariable',
          model: 'minY',
          label: 'Min Y'
        },
        {
          type: 'numberOrVariable',
          model: 'maxY',
          label: 'Max Y'
        },
      ]
    },
    iconName:'CheckboxIntermediate',
    condensedSchema: {
      fields: [
        {
          type: 'displayValueOrVariable',
          model: 'minX',
          label: 'Min X'
        },
        {
          type: 'displayValueOrVariable',
          model: 'maxX',
          label: 'Max X'
        },
        {
          type: 'displayValueOrVariable',
          model: 'minY',
          label: 'Min Y'
        },
        {
          type: 'displayValueOrVariable',
          model: 'maxY',
          label: 'Max Y'
        },
      ]
    }
  },
  {
    type: 'text',
    text: 'Text',
    level: NOOB_LEVEL,
    showInComponentView: false,
    category: categories.create,
    toplevel: true,
    description: [
      "Display some text in the scene."
    ].join("\n"),
    slots: ['link','change'],
    createNew: () => {
      return {
        v:2,
        bounded:true,
        type: 'text',
        text:'',
        size: 24,
        color: '#ffffff',
        wordWrapWidth: 600,
        align: 'center',
        font: 'Arial, Helvetica, sans-serif',
        bg: false,
        bgcolor: '#000000',
        bgx: 9,
        bgy: 1,
        dropShadow: true,
        dropShadowDistance:10,
        dropShadowBlur:20,
        dropShadowColor:'#000000'
      }
    },
    dataSchema: {
      fields: [
        {
          type: 'stringOrVariable',
          model: 'text',
          label: 'Text',
        },
        {
          type: 'color',
          model: 'color',
          label: 'Color'
        },
        {
          type: 'numberOrVariable',
          model: 'size',
          label: 'Size'
        },
        {
          type: 'numberOrVariable',
          model: 'wordWrapWidth',
          label: 'Word Wrap'
        },
        /*
        {
          type:"select",
          label:"Alignment",
          model:"align",
          values:[
            {name:'Left',id:'left'},
            {name:'Center',id:'center'},
            {name:'Right',id:'right'},
          ]
        },
        */
        {
          type: "toggleSwitch",
          label: "Draw background",
          model: "bg",
          default: false
        },

        {
          type: "color",
          label: "Color",
          model: "bgcolor",
          default: '#000000'
        },
        {
          type: "numberOrVariable",
          label: "Background Width",
          model: "bgx",
          default: 9.5
        },
        {
          type: "numberOrVariable",
          label: "Background Height",
          model: "bgy",
          default: 4.5
        },
        /*
        {
          type: 'select',
          model: 'font',
          label: 'Font',

          values:['Arial',
                  'Arial Black',
                  'Comic Sans MS',
                  'Courier New',
                  'Georgia',
                  'Helvetica',
                  'Impact',
                  'Tahoma',
                  'Times New Roman',
                  'Verdana',
                  'Georgia, serif',
                  '"Palatino Linotype", "Book Antiqua", Palatino, serif',
                  '"Times New Roman", Times, serif',
                  'Arial, Helvetica, sans-serif',
                  '"Arial Black", Gadget, sans-serif',
                  '"Comic Sans MS", cursive, sans-serif',
                  'Impact, Charcoal, sans-serif',
                  '"Lucida Sans Unicode", "Lucida Grande", sans-serif',
                  'Tahoma, Geneva, sans-serif',
                  '"Trebuchet MS", Helvetica, sans-serif',
                  'Verdana, Geneva, sans-serif',
                  '"Courier New", Courier, monospace',
                  '"Lucida Console", Monaco, monospace'].map( (font) => {
                    return {name:font,id:font}
                  })
        }
        */
      ]
    },
    condensedSchema: {
      fields: [
          {
            label:'Text',type:'label',model:'text'
          },
      ]
    },
    iconName:'FormatText',
    props:[
      {name:'Text',key:'text'}
    ],
    createLinkTitle:createBySlotNameLinkGrouping('Text')
  },
  /*
    {type:'moveHere', text:'Move Target Here', description:[
      "Moves the target toy to this position"
    ].join("\n"),slots:['link']},
    */
  /*
    {type:'tileMap', text:'Tiled Map', description:[
      "a map yeah"
    ].join("\n"),slots:[]},
    */
  {
    type: 'camera',
    text: 'Camera',
    hidden: true,
    level: SUPERUSER_LEVEL,
    category: categories.scene,
    description: [
      "Camera views the game right?"
    ].join("\n"),
    slots: [{
      name: 'link',
      title: 'Immediate',
      description: 'Creates Immediately'
    },
    /*
      {
        type: 'top',
        name: 'top',
        description: 'Top Edge',
      },
      {
        type: 'right',
        name: 'right',
        description: 'Right Edge',
      },
      {
        type: 'bottom',
        name: 'bottom',
        description: 'Bottom Edge',
      },
      {
        type: 'left',
        name: 'left',
        description: 'Left Edge',
      }
      */
    ],

    createLinkTitle:createDefaultLinkGrouping("When Camera Is Created", "Creates your component as soon as camera is created.")
  },

  {
    type: 'physicsbody2d',
    text: 'Physics',
    level: NOOB_LEVEL,
    limitedMode: true,
    category: categories.physics,
    description: [
      'Enable physics for the toy. It will fall, bounce and collide with other physics toys.'
    ].join("\n"),
    slots: [],
    /*
    slots: (gamedata, c, data) => {
      if (c.bodyType === 'advanced') {
        const sceneData = JSON.parse(c.sceneData);
        let i = 0;
        return sceneData.bodies.map((c) => {
          i++;
          return 'body-' + i;
        });

      } else {
        return ['link'];
      }
    },
    */
    createNew: () => {
      return {
        type: 'physicsbody2d',
        bodyType: 'dynamic',
        shapeType: 'circle',
        density: 1,
        friction: 1,
        restitution: 0.25,
        gravityScale: 1,
        linearDamping: 0,
        angularDamping: 0,
        isSensor: false,
        categoryBits: '',
        maskBits: '',
        groupIndex: '',
        isFixedRotation: false,
        ignoreRotation: false,
        scale: 1,
        scalex: 1,
        scaley: 1,
        tags: ''

      }
    },
    dataSchema: ({component}) => {
      const shapeTypes = [
          {name:'Box',type:'box'},
          {name:'Circle',type:'circle'},
        ];
      const bodyTypes = [
          {name:'Static',type:'static'},
          {name:'Dynamic',type:'dynamic'},
          {name:'Kinematic',type:'kinematic'},
          {name:'Advanced',type:'advanced'}
        ]

      return {
        groups:[{
          label:'Basics',
          fields:[
            {
              type:"select", label:'Body Type', model:'bodyType',
              values:bodyTypes.map( ({name,type}) => {
                return {
                  name,
                  id:type
                }
              })
            },
            {
              type:"select", label:'Shape Type', model:'shapeType',
              values:shapeTypes.map( ({name,type}) => {
                return {
                  name,
                  id:type
                }
              })
            },
            {
              label:"Collision Tags",
              type: "stringOrVariable",
              default: '',
              model:"tags"
            },

          ]
        },
        {
          label:'Behaviour',
          fields:[
            {
              type:'numberOrVariable', label:'Density', model:'density'
            },
            {
              type:'numberOrVariable', label:'Friction', model:'friction'
            },
            {
              type:'numberOrVariable', label:'Restitution', model:'restitution'
            },
            {
              type:'numberOrVariable', label:'Linear Damping', model:'linearDamping'
            },
            {
              type:'numberOrVariable', label:'Angular Damping', model:'angularDamping'
            },
            {
              type:'numberOrVariable', label:'Gravity Scale', model:'gravityScale'
            },

          ]
        },
        {
          label:'Collision Filtering',
          fields:compact([
            {
              type:'numberOrVariable', inputType:'number', label:'Scale', model:'scale'
            },
            component.shapeType === 'box' ?  {
              type:'numberOrVariable', inputType:'number', label:'Scale X', model:'scalex'
            } : undefined,
            component.shapeType === 'box' ?  {
              type:'numberOrVariable', inputType:'number', label:'Scale Y', model:'scaley'
            } : undefined,
            {
              type:'toggleSwitch', label:'Ignore Rotation', model:'ignoreRotation'
            },
            {
              type:'toggleSwitch', label:'Fixed Rotation', model:'isFixedRotation'
            },
            {
              type:'toggleSwitch', label:'Is Sensor', model:'isSensor'
            },
            {
              type:'stringOrVariable', inputType:'text', label:'Category Bits', model:'categoryBits'
            },
            {
              type:'stringOrVariable', inputType:'text', label:'Mask Bits', model:'maskBits'
            },
            {
              type:'stringOrVariable', inputType:'number', label:'Group Index', model:'groupIndex'
            },
          ])
        }
        ]


      }

    },
    condensedSchema: {
      tag: 'div',
      fields:[
        {
          type: "displayValueOrVariable", label: "Type", model: "bodyType",
        },
        {
          type: "displayValueOrVariable", label: "Shape", model: "shapeType",
        },
      ]
    },

    iconName: 'Axis',
    props:[
    {name:'Body Type', key:'bodyType'},
    {name:'Friction', key:'friction'},
    {name:'Density', key:'density'},
    {name:'Restitution', key:'restitution'},
    ],
    createLinkTitle:createDefaultLinkGrouping("When Physics Is Created", "Creates your component as soon as physics has been enabled on the toy.")
  },

  {
    type: 'changebodytype',
    text: 'Change Physics Body Type(2D)',
    level: ADVANCED_LEVEL,
    category: categories.physics,
    description: [
      '2d physics yeah'
    ].join("\n"),
    slots: ['link']
  },
  /*

    {type:'addfixture', text:'Add Physics Fixture (2D)', description:[
      'add a fixture to a physics body'
    ].join("\n"),slots:['link']},
    */

  {
    type: 'applyimpulse2d',
    text: 'Apply Impulse (2D)',
    level: NOOB_LEVEL,
    category: categories.physics,
    description: [
      'Applies an instantaneous impuse to a physics body. Think of it like jumping. Only works on dynamic bodies!'
    ].join("\n"),
    slots: [],
    createNew: () => {
      return {
        type: 'applyimpulse2d',
        impulsex: 0,
        impulsey: -10
      }
    },
    dataSchema: {
      fields: [
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "X Impulse",
          model: "impulsex",
        },
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "Y Impulse",
          model: "impulsey",
        }
      ]
    },
    condensedSchema: {
      fields: [
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "X",
          model: "impulsex",
        },
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "Y",
          model: "impulsey",
        }
      ]
    },

  },

  {
    type: 'applyforce2d',
    text: 'Apply Force (2D)',
    level: NOOB_LEVEL,
    category: categories.physics,
    description: [
      'Applies a force to physics bodies. Think of it like a rocket booster. Only works on dynamic bodies!'
    ].join("\n"),
    slots: [
      {
        name: 'link',
        description: 'Force Starts'
      },
      {
        name: 'busy',
        description: 'Force Active'
      },
      {
        name: 'end',
        description: 'Force Ends'
      },
      {
        name: 'maxed',
        description: 'Force Maxed'
      },
    ],
    createLinkTitle({name}) {
      if (name === 'link') {
        return {
          title:'When The Force Is Created',
          description:'Creates your feature when force is created.',
          name:'link'
        }
      } else if (name === 'busy') {
        return {
          title:'When The Force Is Active',
          description:'Creates your feature while the force is active',
          name:'busy'
        }
      } else if (name === 'end') {
        return {
          title:'When The Force Ends',
          description:'Creates your feature when the force is finished',
          name:'busy'
        }
      } else if (name === 'maxed') {
        return {
          title:'When The Force Is Maxed',
          description:'Creates your feature then the force is maxed out',
          name:'busy'
        }
      }
    },

    createNew: () => {
      return {
        type: 'applyforce2d',
        forcex: 1,
        forcey: -60,
        offsetx: 0,
        offsety: 0,
        keep: false,
        time: 0.5,
        maxVelocity: 0
      }
    },
    dataSchema: {
      fields: [
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "X Force",
          model: "forcex",
        },
        {
          type: "numberOrVariable",
          inputType: "number",
          label: "Y Force",
          model: "forcey",
        },
        {
          type: "toggleSwitch",
          label: "Keep Force Indefinitely",
          model: "keep",
        },
        {
          type: "numberOrVariable",
          label: "Force Duration (seconds)",
          model: "time",
        },
        {
          type: "numberOrVariable",
          label: "Max Velocitoy",
          model: "maxVelocity",
        },
      ]
    },
    condensedSchema: {
      fields: [
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "X",
          model: "forcex",
        },
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "Y",
          model: "forcey",
        }
      ]
    },

  },

  {
    type: 'setcollisionfilter',
    text: 'Physics Set Collision Filter',
    level: ADVANCED_LEVEL,
    category: categories.physics,
    description: [
      'set collision filters for physics to determine who collides with who'
    ].join("\n"),
    slots: ['link']
  },

  {
    type: 'setlinearvelocity2d',
    text: 'Set Velocity',
    level: NOOB_LEVEL,
    category: categories.physics,
    description: [
      'Instantly sets the velocity of a physics body. Think of it moving a character to the right or left at a constant speed.'
    ].join("\n"),
    slots: [],
    iconName: 'AxisArrow',
    createNew:() => {
      return {
        type: 'setlinearvelocity2d',
        setx: false,
        sety: true,
        x: 0,
        y: -2,
        setangle: false,
        continous: false,
      }
    },
    dataSchema:{
      fields:[
        {
          type: "toggleSwitch",
          label: "Set X",
          model: "setx"
        },
        {
          type: "numberOrVariable",
          label: "X",
          model: "x",
        },
        {
          type: "toggleSwitch",
          label: "Set Y",
          model: "sety"
        },
        {
          type: "numberOrVariable",
          label: "Y",
          model: "y",
        },
      ],
    },
    condensedSchema: {
      fields: [
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "X",
          model: "x",
        },
        {
          type: "displayValueOrVariable",
          inputType: "number",
          label: "Y",
          model: "y",
        }
      ]
    },

  },

  {
    type: 'gotoscene',
    text: 'Goto Scene',
    level: ADVANCED_LEVEL,
    limitedMode: true,
    category: categories.scene,
    description: [
      'Changes to a different scene'
    ].join("\n"),
    slots: ['before', 'after'],
    iconName: 'FolderMultipleImage'
  },
  {
    type: 'gotoGame',
    text: 'Goto Game',
    level: SUPERUSER_LEVEL,
    category: categories.scene,
    description: [
      'Goto to a different game'
    ].join("\n"),
    slots: ['before', 'after']
  },
  {
    type: 'setbodyproperties',
    text: 'Set Body Properties (2D)',
    level: SUPERUSER_LEVEL,
    category: categories.physics,
    description: [
      'set body properties, such as x and y, rotation'
    ].join("\n"),
    slots: ['link']
  },
  {
    type: 'gridTransform',
    text: 'Put On Grid',
    level: NOOB_LEVEL,
    createNew: () => {
      return {
        type: 'gridTransform',
        gridx: 1,
        gridy: 1
      }
    },
    funky: true,
    category: categories.scene,
    hidden: false,
    toplevel: true,
    slots: ['link'],
    createChild: (component) => {
      return {
        vars: {
          gridx: component.gridx || 1,
          gridy: component.gridy || 1,
        }
      }
    }
  },

  {
    type:'generic',
    text:'?',
    iconName:'HelpCircle',
    props:[
      {name:'Unknown Type',key:'type'}
    ],
    createLinkTitle:createDefaultLinkGrouping("Dont know")
  },


    {
      level: NOOB_LEVEL,
      type:'sequence',
      text:'Steps', description:[
        'On each activation, active the next feature, like a sequence of steps.'
      ].join("\n"),
      slots: (gamedata, c, partutil, transform) => {
        const links = uniqBy(
          partutil.findComponentsAndLinksFrom(c)
          .links
          .filter( ({name}) => {
            return name !== 'change';
          }), 'name');
        const times = Math.max(links.length + 3, 5);
        return range(1,times+1).map( (i) => {
          const name = '' + i;
          const description = "Step " + i;
          return {
            name,
            description
          }
        }).concat( {
          name:'change',
          description:'When Step Changes'
        });
      },
      iconName:'FormatListNumbered',
      category: categories.scripting,
      createNew: () => {
        return {
          loop: true,
          reverse: false,
          firstStep: true,
          type:'sequence'
        }
      },
      dataSchema:{
        fields:[
            {
              type: "toggleSwitch",
              label: "Auto activate first step",
              model: "firstStep",
              default:true
            },
            {
              type: "toggleSwitch",
              label: "Loop at end",
              model: "loop",
              default:false
            },
            {
              type: "eventsSelector",
              label: "Reset Event",
              model: "resetEvent",
              default:''
            },
            {
              type: "eventsSelector",
              label: "Advance Event",
              model: "advanceEvent",
              default:''
            },
            {
              type: "toggleSwitch",
              label: "Reverse at end",
              model: "reverse",
              default:false
            },
        ],
      },
      condensedSchema: {
        fields:[
          {
            type: "displayValueOrVariable",
            inputType: "boolean",
            label: "Loop at end",
            model: "loop",
          }
        ],
      },
      createLinkTitle:createSequenceLinkGrouping
    },
    {
      level: NOOB_LEVEL,
      type:'followpointer',
      __builtin: FloatieFeature.id,
      text:'Follow Pointer', description:[
        'The toy follows the users\' pointer or finger'
      ].join("\n"),
      slots: (gamedata, c, partutil, transform) => {
        return []
      },
      iconName:'Gesture',
      category: categories.input,
      createNew: () => {
        return {
          type:'feature',
          builtin:FloatieFeature
        }
      },
      dataSchema:{
        fields:[
        ],
      },
      condensedSchema: {
        fields:[
        ],
      },
      createLinkTitle:createDefaultLinkGrouping()
    },
    {
      level: NOOB_LEVEL,
      type:'draghorizontal',
      __builtin: DragLeftRightFeature.id,
      text:'Drag Horizontal', description:[
        'Drag the toy in the horizontal direction'
      ].join("\n"),
      slots: (gamedata, c, partutil, transform) => {
        return []
      },
      iconName:'Gesture',
      category: categories.input,
      createNew: () => {
        return {
          type:'feature',
          builtin:DragLeftRightFeature
        }
      },
      dataSchema:{
        fields:[
        ],
      },
      condensedSchema: {
        fields:[
        ],
      },
      createLinkTitle:createDefaultLinkGrouping()
    },
    {
      level: NOOB_LEVEL,
      type:'dragvertical',
      __builtin: DragTopDownFeature.id,
      text:'Drag Vertical', description:[
        'Drag the toy in the vertical direction'
      ].join("\n"),
      slots: (gamedata, c, partutil, transform) => {
        return []
      },
      iconName:'Gesture',
      category: categories.input,
      createNew: () => {
        return {
          type:'feature',
          builtin:DragTopDownFeature
        }
      },
      dataSchema:{
        fields:[
        ],
      },
      condensedSchema: {
        fields:[
        ],
      },
      createLinkTitle:createDefaultLinkGrouping()
    },

    {
      level: NOOB_LEVEL,
      type:'cameraFollows',
      text:'Camera Follows', description:[
        'Makes the camera follow this toy.',
      ].join("\n"),
      slots: ['moving','begin','finish'],
      iconName:'Camera',
      category: categories.animations,
      createNew: () => {
        return {
          type:'cameraFollows',
        }
      },
      dataSchema:{
        fields:[
        ],
      },
      condensedSchema: {
        fields:[
        ],
      },
      createLinkTitle: function createTweenLinkGrouping({name}) {
        if (name === 'begin') {
          return {
            title:'When Camera Starts Moving',
            description:'Creates your feature when the camera starts moving.',
            name:'begin'
          }
        } else if (name === 'moving') {
          return {
            title:'When Camera Is Busy Moving',
            description:'Creates your feature when the camera is busy moving.',
            name:'moving'
          }
        } else if (name === 'finish') {
          return {
            title:'When Camera Finishes Moving',
            description:'Creates your feature when the camera stops moving.',
            name:'finish'
          }
        }

      }

    },
    {
      level: NOOB_LEVEL,
      type:'playAnimation',
      text:'Play Animation', description:[
        'Start playing an animation from the available animations'
      ].join("\n"),
      //slots: ['begin','finish', 'interrupted'],
      slots: [],
      iconName:'Video',
      category: categories.animations,
      createNew: () => {
        return {
          type:'playAnimation',
        }
      },
      dataSchema:{
        fields:[
        ],
      },
      condensedSchema: {
        fields:[
        ],
      },
      createLinkTitle: function createTweenLinkGrouping({name}) {
        if (name === 'begin') {
          return {
            title:'When Camera Starts Moving',
            description:'Creates your feature when the camera starts moving.',
            name:'begin'
          }
        } else if (name === 'moving') {
          return {
            title:'When Camera Is Busy Moving',
            description:'Creates your feature when the camera is busy moving.',
            name:'moving'
          }
        } else if (name === 'finish') {
          return {
            title:'When Camera Finishes Moving',
            description:'Creates your feature when the camera stops moving.',
            name:'finish'
          }
        }

      }

    },



  /*
      {type:'applyjoint', text:'Apply Joint (2D)', description:[
        'Apply a joint to this and another?'
      ].join("\n"),slots:['link']},

      {type:'removejoints', text:'Remove All Joints (2D)', description:[
        'Remove all joints from this body'
      ].join("\n"),slots:['link']},
      */

], (x) => {
  return x.text;
})

const types = {};
typeList.forEach((type) => {
  types[type.type] = type;
})

const categoriesList = Object.values(categories);

const iconSize = 16;

function createLinkGrouping(componentsAndLinks, createLinkName) {
  const groupedByLinkName = groupBy(componentsAndLinks, 'link.name');
  const linkGroupings = {
  }
  toPairs(groupedByLinkName).forEach( ([key, value]) => {
    const link = value[0].link;
    const {title} = createLinkName(link);
    const linkName = title;
    if (!linkGroupings[linkName]) {
      linkGroupings[linkName] = {
        name:linkName,
        components:[]
      }
    }
    value.forEach( ({component}) => {
      linkGroupings[linkName].components.push(component);
    });
  });

  return Object.values(linkGroupings);
}

function createComponent(type, component) {
  if (component && component.createNew) {
    return component.createNew();
  }
  if (types[type].createNew) {
    return types[type].createNew();
  } else {
    return {
      type
    }
  }
}
function createLink(component, link) {
  const componentType = component.type;
  const linkType = link.name;
  if (types[componentType].createNewLink) {
    return types[componentType].createNewLink(linkType);
  } else {
    return {name:linkType};
  }
}

function findDbEntry(component) {
  const type = component.type;
  let dbentry = types[type];
  if ((component.builtin && type === 'feature') || type.__builtin) {
    dbentry = typeList.filter( (type) => {
      if (type.__builtin) {
        return type.__builtin === component.builtin.id;
      } else {
        return false;
      }
    })[0];
  }
  return dbentry;
}

function createSlots(component, partutil, transform) {
  const dbentry = types[component.type];
  function defaultCreateLinkTitle({name}) {
    return {
      title:name
    };
  }
  let createLinkTitle = defaultCreateLinkTitle;
  if (typeof(dbentry.createLinkTitle) !== 'undefined') {
    createLinkTitle = dbentry.createLinkTitle;
  }
  const createSlots = dbentry.slots;
  let links;
  if (isFunction(createSlots)) {
    links = createSlots(partutil.gamedata.gamedata, component, partutil, transform);
  } else {
    links = createSlots;
  }
  links = links.map( (link) => {
    if (isString(link)) {
      const titleAndDescription = createLinkTitle({name:link});
      return titleAndDescription;
    } else {
      return createLinkTitle(link);
    }
  });
  return links;
}

function createLinkTitle(component, link) {
  const dbentry = findDbEntry(component);
  return dbentry.createLinkTitle(link);
}

export {
  typeList,
  categoriesList,
  categories,
  types,
  iconSize,
  createLinkGrouping,
  createLinkTitle,
  createComponent,
  createLink,
  createSlots,
  ADVANCED_LEVEL,
  NOOB_LEVEL,
  SUPERUSER_LEVEL,
  findDbEntry
}

